import type { CategoryPages } from './types';

export const COMPACT_LIMIT = 5;

export type ClusterGroup = [clusterId: string, pages: CategoryPages];

export type PreviewLayoutProps = {
  pagesGrouped: ClusterGroup[];
  category: string | undefined;
  tint: boolean;
  compact: boolean;
  expanded: Set<string>;
  onExpand: (clusterId: string) => void;
  resize: string;
};

// In compact mode a cluster shows the first COMPACT_LIMIT pages until the user
// expands it; otherwise every page is shown. `hidden` drives the "+N" tile.
export function splitCluster(clusterPages: CategoryPages, clusterId: string, compact: boolean, expanded: Set<string>) {
  const collapsed = compact && !expanded.has(clusterId);
  const shown = collapsed ? clusterPages.slice(0, COMPACT_LIMIT) : clusterPages;
  return { shown, hidden: collapsed ? clusterPages.length - shown.length : 0 };
}
